import React from "react";
import NcInputNumber from "components/common/NcInputNumber";
import NcInputNumberAdult from "components/common/NcInputNumberAdult";
import { FC } from "react";
import Modal from "components/ui/Modal";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { UserAddIcon } from "@heroicons/react/outline";
export interface TravelersInputValue {
  adults: number;
  children: number;
  infants: number;
}

export interface TravelersInputProps {
  travelers: TravelersInputValue;
  setTravelers: (value: TravelersInputValue) => void;
  iconClassName?: string;
  labelClassName?: string;
  subtitleClassName?: string;
  subtitle?: boolean;
  className?: string;
}

const TravelersInputWithoutModal: FC<TravelersInputProps> = ({
  travelers,
  setTravelers,
  iconClassName = "",
  labelClassName = "",
  subtitleClassName = "",
  className = "",
  subtitle = true,
}) => {
  const { t } = useTranslation();

  const numOfTravelers =
    travelers.adults + travelers.children + travelers.infants;
  return (
    <div className="space-x-2 flex py-2 items-center ">
           <div>
            <UserAddIcon
              className={cn(
                "nc-icon-field mb-1 text-neutral-300 dark:text-neutral-400",
                iconClassName
              )}
            />
          </div>
      <div>
        <NcInputNumberAdult
          defaultValue={travelers.adults}
          onChange={(adults) => setTravelers({ ...travelers, adults })}
          label={t("generals.adult")}
          className={"pr-4"}
        />
      </div>
      <div>
        <NcInputNumber
          defaultValue={travelers.children}
          onChange={(children) => setTravelers({ ...travelers, children })}
          label={t("generals.child")}
          className={"pr-4"}

        />
      </div>
      <div>
        <NcInputNumber
          defaultValue={travelers.infants}
          onChange={(infants) => setTravelers({ ...travelers, infants })}
          label={t("generals.infant")}
          className={"pr-4"}

        />
      </div>
    </div>
  );
};


export default TravelersInputWithoutModal;
